import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Normalize an email for comparison purposes.
 * - Lowercases and trims
 * - For Gmail addresses, removes dots from the local part
 *   (Gmail ignores dots: john.doe@gmail.com == johndoe@gmail.com)
 * - Non-Gmail addresses are returned as-is (lowercased/trimmed)
 */
export function normalizeEmail(email: string): string {
  const cleaned = email.toLowerCase().trim();
  const [localPart, domain] = cleaned.split('@');
  if (!domain) return cleaned;
  if (domain === 'gmail.com') {
    return `${localPart.replace(/\./g, '')}@gmail.com`;
  }
  return cleaned;
}
